// strategiesData.js - Fichier de données JSON mis à jour
import {
    Calendar,
    Copy,
    Hammer,
    Home,
    Package,
    RefreshCw,
    TrendingUp,
    Users
} from 'lucide-react';

export const strategiesData = {
    'achat-revente': {
        id: 'achat-revente',
        name: 'Achat-Revente',
        description: 'Acheter, rénover et revendre rapidement',
        duration: '6-18 mois',
        risk: 'Élevé',
        level: 'Intermédiaire',
        roi: '15-30%',
        icon: TrendingUp,
        advantages: [
            'Plus-values importantes possibles',
            'Contrôle total du projet',
            'Apprentissage des techniques',
            'Retour sur investissement rapide'
        ],
        disadvantages: [
            'Investissement initial élevé',
            'Gestion de chantier complexe',
            'Risques de dépassement budgétaire',
            'Immobilisation longue des fonds'
        ],
        tips: [
            'Chiffrer précisément les travaux avant achat',
            'Prévoir 20% de marge d\'erreur sur le budget',
            'Choisir des matériaux avec bon rapport qualité/prix',
            'Superviser régulièrement l\'avancement du chantier'
        ],
        requirements: [
            'Apport minimum 30%',
            'Réseau d\'artisans fiables',
            'Compétences en gestion de projet'
        ]
    },
    'location-longue-duree': {
        id: 'location-longue-duree',
        name: 'Location Longue Durée',
        description: 'Investissement locatif traditionnel',
        duration: '10+ ans',
        risk: 'Faible',
        level: 'Débutant',
        roi: '3-6%',
        icon: Home,
        advantages: [
            'Revenus réguliers et prévisibles',
            'Faible gestion quotidienne',
            'Stabilité locative',
            'Avantages fiscaux (Pinel, etc.)'
        ],
        disadvantages: [
            'Rendement plus faible',
            'Risques d\'impayés',
            'Évolution lente de la valeur',
            'Contraintes légales strictes'
        ],
        tips: [
            'Bien sélectionner les locataires',
            'Souscrire une assurance loyers impayés',
            'Maintenir le bien en bon état',
            'Réviser les loyers selon l\'indice légal'
        ],
        requirements: [
            'Apport minimum 20%',
            'Capacité de gestion locative',
            'Connaissance du droit locatif'
        ]
    },
    'location-courte-duree': {
        id: 'location-courte-duree',
        name: 'Location Courte Durée',
        description: 'Airbnb, locations saisonnières',
        duration: '5-10 ans',
        risk: 'Moyen',
        level: 'Intermédiaire',
        roi: '6-12%',
        icon: Calendar,
        advantages: [
            'Rendements élevés',
            'Flexibilité d\'usage personnel',
            'Optimisation tarifaire dynamique',
            'Contact direct avec les clients'
        ],
        disadvantages: [
            'Gestion intensive et chronophage',
            'Saisonnalité forte',
            'Réglementation changeante',
            'Concurrence accrue sur les plateformes'
        ],
        tips: [
            'Choisir un emplacement touristique ou d\'affaires',
            'Soigner la décoration et les équipements',
            'Optimiser les photos et descriptions',
            'Automatiser la gestion avec des outils'
        ],
        requirements: [
            'Emplacement stratégique',
            'Disponibilité pour gestion active',
            'Compétences en service client'
        ]
    },
    'colocation': {
        id: 'colocation',
        name: 'Colocation',
        description: 'Location par chambre, étudiants',
        duration: '5-10 ans',
        risk: 'Moyen',
        level: 'Intermédiaire',
        roi: '7-10%',
        icon: Users,
        advantages: [
            'Rendement supérieur au locatif classique',
            'Diversification des risques locatifs',
            'Marché étudiant stable',
            'Possibilité de location meublée'
        ],
        disadvantages: [
            'Gestion plus complexe (plusieurs locataires)',
            'Turnover plus fréquent',
            'Usure accélérée du mobilier',
            'Conflits potentiels entre colocataires'
        ],
        tips: [
            'Cibler les zones universitaires ou d\'affaires',
            'Proposer des espaces communs de qualité',
            'Établir un règlement de colocation clair',
            'Prévoir du mobilier résistant'
        ],
        requirements: [
            'Bien adapté à la colocation',
            'Gestion multi-locataires',
            'Proximité écoles/transports'
        ]
    },
    'renovation-lourde': {
        id: 'renovation-lourde',
        name: 'Rénovation Lourde',
        description: 'Gros travaux, restructuration complète',
        duration: '12-24 mois',
        risk: 'Très élevé',
        level: 'Expert',
        roi: '20-40%',
        icon: Hammer,
        advantages: [
            'Potentiel de plus-value très élevé',
            'Transformation complète du bien',
            'Valorisation maximale',
            'Satisfaction de créer quelque chose d\'unique'
        ],
        disadvantages: [
            'Risques techniques et financiers majeurs',
            'Délais souvent dépassés',
            'Gestion de chantier très complexe',
            'Immobilisation importante de capital'
        ],
        tips: [
            'Faire réaliser un diagnostic technique complet',
            'Prévoir 30-40% de marge sur le budget initial',
            'S\'entourer de professionnels expérimentés',
            'Sécuriser les financements avant de commencer'
        ],
        requirements: [
            'Expérience confirmée en rénovation',
            'Budget important disponible',
            'Réseau d\'artisans de confiance'
        ]
    },
    'division-creation-lot': {
        id: 'division-creation-lot',
        name: 'Division / Création de Lot',
        description: 'Diviser un bien en plusieurs lots',
        duration: '8-15 mois',
        risk: 'Élevé',
        level: 'Expert',
        roi: '25-50%',
        icon: Copy,
        advantages: [
            'Multiplication des revenus locatifs',
            'Valorisation importante du bien',
            'Diversification des risques locatifs',
            'Optimisation fiscale possible'
        ],
        disadvantages: [
            'Procédures administratives complexes',
            'Coûts de division importants',
            'Contraintes techniques et légales',
            'Gestion multiple plus complexe'
        ],
        tips: [
            'Vérifier la faisabilité juridique avant achat',
            'Prévoir les coûts de mise aux normes',
            'Étudier la demande locative par typologie',
            'Anticiper les frais de copropriété'
        ],
        requirements: [
            'Connaissance du droit de la copropriété',
            'Budget pour travaux de division',
            'Autorisation urbanisme et copropriété'
        ]
    },
    'vente-a-la-decoupe': {
        id: 'vente-a-la-decoupe',
        name: 'Vente à la Découpe',
        description: 'Acheter en bloc, vendre lot par lot',
        duration: '6-12 mois',
        risk: 'Très élevé',
        level: 'Expert',
        roi: '30-60%',
        icon: Package,
        advantages: [
            'Plus-values exceptionnelles possibles',
            'Rotation rapide du capital',
            'Exploitation des écarts de prix',
            'Contrôle total de la stratégie'
        ],
        disadvantages: [
            'Risque de mévente élevé',
            'Immobilisation importante de capital',
            'Complexité juridique et administrative',
            'Sensibilité aux fluctuations du marché'
        ],
        tips: [
            'Analyser précisément le marché local',
            'Prévoir plusieurs scénarios de vente',
            'Sécuriser les promesses de vente',
            'Négocier des conditions d\'achat flexibles'
        ],
        requirements: [
            'Expertise approfondie du marché',
            'Capacité financière très importante',
            'Réseau d\'acquéreurs potentiels'
        ]
    },
    'sous-location': {
        id: 'sous-location',
        name: 'Sous-Location',
        description: 'Louer pour re-louer avec plus-value',
        duration: '1-3 ans',
        risk: 'Moyen',
        level: 'Débutant',
        roi: '5-15%',
        icon: Home,
        advantages: [
            'Faible investissement initial',
            'Pas d\'achat immobilier nécessaire',
            'Flexibilité et mobilité',
            'Apprentissage de la gestion locative'
        ],
        disadvantages: [
            'Dépendance au propriétaire principal',
            'Risques juridiques importants',
            'Marges limitées',
            'Réglementation stricte'
        ],
        tips: [
            'Vérifier la légalité de la sous-location',
            'Obtenir l\'accord écrit du propriétaire',
            'Bien calculer la marge bénéficiaire',
            'Souscrire une assurance adaptée'
        ],
        requirements: [
            'Autorisation du propriétaire',
            'Connaissance du droit locatif',
            'Capital de départ limité'
        ]
    },
    'changement-destination': {
        id: 'changement-destination',
        name: 'Changement de Destination',
        description: 'Transformer usage : bureaux en logements, etc.',
        duration: '12-36 mois',
        risk: 'Très élevé',
        level: 'Expert',
        roi: '40-80%',
        icon: RefreshCw,
        advantages: [
            'Potentiel de valorisation exceptionnel',
            'Création de valeur par transformation',
            'Opportunités de marché uniques',
            'Différenciation concurrentielle forte'
        ],
        disadvantages: [
            'Procédures administratives très longues',
            'Coûts de transformation importants',
            'Risques de refus administratif',
            'Complexité technique majeure'
        ],
        tips: [
            'Étudier la faisabilité réglementaire en amont',
            'Prévoir 18-24 mois de procédures',
            'S\'entourer d\'experts spécialisés',
            'Sécuriser les financements sur la durée'
        ],
        requirements: [
            'Expertise juridique et technique',
            'Budget conséquent pour transformation',
            'Patience et vision long terme'
        ]
    }
};